import React from 'react';
import { Switch, Route, useLocation, Redirect, BrowserRouter } from 'react-router-dom';
import { routes, switchRoutes } from 'core/router/router';
import { DossierOrchestrationManager, DossierProvider, DossierStatusManager } from 'common-app/dossier';
import { DossierRouter } from './router-dossier.component';
import { CustomAutologinScene } from 'scenes/user/login/custom-autologin';
import { AutoLoginLayout, AutoLoginLoggedForm } from '@isyc-react/auth/modules/pods/login';
export const RouterLogged = () => {
    const location = useLocation();
    return (React.createElement(Switch, { location: location },
        React.createElement(Route, { path: [switchRoutes.autologin.base] },
            React.createElement(BrowserRouter, null,
                React.createElement(AutoLoginLayout, null,
                    React.createElement(AutoLoginLoggedForm, null)))),
        React.createElement(Route, { exact: true, path: [switchRoutes.customAutologin] },
            React.createElement(CustomAutologinScene, null)),
        React.createElement(Route, { path: [switchRoutes.dossierWithId.root, switchRoutes.root, switchRoutes.dossier.root] },
            React.createElement(DossierProvider, null,
                React.createElement(DossierStatusManager, null,
                    React.createElement(DossierOrchestrationManager, { activated: true },
                        React.createElement(DossierRouter, null))))),
        React.createElement(Route, { path: '*' },
            React.createElement(Redirect, { to: routes.dossier.root }))));
};
